import { Button, Divider, Group, Stack, Text, TextInput } from "@mantine/core";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks";

import { fetchMaconomyAndHydrateAkustikkGenerellInfoThunk, setAkustikkValue } from "./akustikkRapportThunks";

export const AkustikkGenerellInfo: React.FC = () => {
  const dispatch = useAppDispatch();

  const edited = useAppSelector((state) => state.reportReducer.editedData[401]);
  if (!edited) return null;

  return (
    <Stack>
      <Divider
        my="sm"
        label={
          <Text fz="md" fw={600}>
            Generell informasjon
          </Text>
        }
        mb="xs"
      />
      <Button onClick={() => dispatch(fetchMaconomyAndHydrateAkustikkGenerellInfoThunk())}>
        Last ned data fra maconomy
      </Button>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Oppdragsnavn:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.oppdragsnavn}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.oppdragsnavn", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Oppdragsgiver:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.oppdragsgiver}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.oppdragsgiver", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Emne:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.emne}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.emne", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Dokumentkode:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.dokumentkode}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.dokumentkode", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Kontaktperson:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.kontaktperson}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.kontaktperson", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Tilgjengelighet:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.tilgjengelighet}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.tilgjengelighet", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Oppdragsleder:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.oppdragsleder}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.oppdragsleder", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Utarbeidet av:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.utarbeidetAv}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.utarbeidetAv", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Ansvarlig enhet:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.ansvarligEnhet}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.ansvarligEnhet", e.currentTarget.value))}
          flex={1}
        />
      </Group>
      <Group gap="sm" align="center">
        <Text w={120} size="sm">
          Revisjon:
        </Text>
        <TextInput
          size="sm"
          value={edited.generellInfo.revisjon}
          onChange={(e) => dispatch(setAkustikkValue("generellInfo.revisjon", e.currentTarget.value))}
          flex={1}
        />
      </Group>
    </Stack>
  );
};
